import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { DepartmentArgOptions, DepartmentResMock } from '../types/department.types'
import { ShiftResMocks } from '../types/shift.type'

export const useShift = (arg?: DepartmentArgOptions) => {
  const shiftId = arg?.id
  const page = arg?.page
  const pageSize = arg?.limit
  const query = arg?.query

  const { data: shift, isLoading } = useQuery({
    queryFn: async () => {
      let endpoint = 'shifts?'
      if (page) endpoint += `page%5Bnumber%5D=${page}&page%5Bsize%5D=${pageSize}`
      if (query) endpoint += `${endpoint}&query=${query}`

      const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<ShiftResMocks[]>>(endpoint)
      return data
    },
    queryKey: ['shifts', { page, pageSize, query }]
  })

  const { data: singleShift } = useQuery({
    enabled: !!shiftId,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<ShiftResMocks>>(`shifts/${shiftId}`)
      return data.data
    },
    queryKey: ['shifts', shiftId]
  })

  const { mutateAsync: addShift } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`shifts`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['shifts'] })
  })

  const { mutateAsync: updateShift } = useMutation({
    mutationFn: async ({ data, id }: { data: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`shifts/${id}`, data, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['shifts'] })
  })

  const { mutateAsync: deleteShift } = useMutation({
    mutationFn: async (id: string) => {
      await AXIOS_INSTANCE.delete(`shifts/${id}`)
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['shifts'] })
  })

  return {
    addShift,
    deleteShift,
    isLoading,
    shiftPagination: shift?.meta?.pagination,
    shifts: shift?.data,
    singleShift,
    updateShift
  }
}
